import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On route change, scrolls to the top of the page - unless the URL has a
 * hash (e.g. "/#donate"), in which case it scrolls that element into view.
 * Should be rendered inside BrowserRouter, above <Routes>.
 */
function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let frame;
      let attempts = 0;

      // The target route may not have rendered yet (e.g. navigating here from
      // another page), so retry for a short while until the element exists.
      const scrollToTarget = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempts < 20) {
          attempts += 1;
          frame = requestAnimationFrame(scrollToTarget);
        } else {
          window.scrollTo(0, 0);
        }
      };

      frame = requestAnimationFrame(scrollToTarget);
      return () => cancelAnimationFrame(frame);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, key]);

  return null;
}

export default ScrollToTop;
